"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertFanApiFactory = void 0;
const generated_1 = require("./generated");
class ApiIndex {
    constructor(alertsApi, tagsApi, silencesApi, historyApi) {
        this.alertsApi = alertsApi;
        this.tagsApi = tagsApi;
        this.silencesApi = silencesApi;
        this.historyApi = historyApi;
    }
}
const AlertFanApiFactory = (axios, basePath) => {
    const alertsApi = new generated_1.AlertfanAlertsApi(undefined, basePath, axios);
    const tagsApi = new generated_1.AlertfanTagsApi(undefined, basePath, axios);
    const silencesApi = new generated_1.AlertfanSilencesApi(undefined, basePath, axios);
    const historyApi = new generated_1.AlertfanHistoryApi(undefined, basePath, axios);
    return Object.freeze(new ApiIndex(alertsApi, tagsApi, silencesApi, historyApi));
};
exports.AlertFanApiFactory = AlertFanApiFactory;
//# sourceMappingURL=api.js.map